import { AdminAppState, Image } from '../../state';
import { getImage } from './get-image';

export const getImageUrl = (imageKey: string) => (
  state: AdminAppState,
): Image['url'] => getImage(imageKey)(state).url;
